import { ISearchable } from './Searchable.itf'
/**
* @typedef  PoissonConditionnementConstructor
* @type {object}
* @property {Object} idConditionnement - the idConditionnement value
* @property {string} nom - the nom value
* @author generator-sqlite
* */

export class PoissonConditionnement extends ISearchable {
  /**
   * Creates an instance of PoissonConditionnement.
   * @memberof PoissonConditionnement
   * @author generator-sqlite
   * */
  constructor(object) {
    super()
    this.idConditionnement = object.idConditionnement
    this.nom = object.nom
  }

  formatToDisplay() {
    this.nom = this.nom.charAt(0).toUpperCase() + this.nom.substring(1).toLowerCase()
    this.lineClassName = 'condLine'
    this.boxClassName = 'condBox'
    this.displayType = 'Découpe'
    this.raccourci = this.nom
    this.created = true

    return this
  }

  formatToCreate() {
    this.formatToDisplay()
    this.created = false
    this.lineClassName = 'create-condLine'
    return this
  }

  getNameAttribute() {
    return 'nom'
  }

  getIdAttribute() {
    return 'idConditionnement'
  }

  getRaccourciAttribute() {
    return 'raccourci'
  }
}
